import { createContext } from 'react';
import { IMenuTranslation, IItemForGetShortInfo, TFileId, TLanguageIDs, IFileData, IEditVideo } from 'types';

export type TEditVideoVisibleForm = 'mainForm' | 'translations';
export type TSourceUrlLocally = Nullable<string>;
export type TEditVideoSelectedItem = Nullable<string>;
export type TTypeOfEditVideoModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'fileSizeExceeded'
	| 'fileUploadError'
	| 'invalidFileFormat'
	| 'createStudio'
	| 'someTranslationIsEmpty';
export interface IInitialFormData {
	IDSelectedStudio: TEditVideoSelectedItem;
	name: string;
	IDSelectedCategory: TEditVideoSelectedItem;
	iconFilePath: string;
	videoFileData: IFileData;
	IDsSelectedLanguages: TLanguageIDs[];
	translations: IMenuTranslation[];
}

export interface IEditVideoState {
	needRefetchData: boolean;
	initialFormData: IInitialFormData | null;
	videoID: string;
	visibleForm: TEditVideoVisibleForm;
	iconFilePath: string | null;
	iconFileId: TFileId;
	fetchedStudios: IItemForGetShortInfo[];
	IDSelectedStudio: TEditVideoSelectedItem;
	needRefetchStudios: boolean;
	name: string;
	fetchedCategories: IItemForGetShortInfo[];
	IDSelectedCategory: TEditVideoSelectedItem;
	videoFilePath: string | null;
	videoFileData: IFileData;
	fetchedLanguages: IItemForGetShortInfo[];
	IDsSelectedLanguages: TLanguageIDs[];
	dataForSubmit: IEditVideo | null;
	typeOfModalWindow: TTypeOfEditVideoModalWindow;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IMenuTranslation[];
}

export const editVideoInitialState: IEditVideoState = {
	needRefetchData: false,
	initialFormData: null,
	videoID: '',
	visibleForm: 'mainForm',
	iconFilePath: null,
	iconFileId: null,
	fetchedStudios: [],
	IDSelectedStudio: null,
	needRefetchStudios: false,
	name: '',
	fetchedCategories: [],
	IDSelectedCategory: null,
	videoFilePath: null,
	videoFileData: {
		fileId: '',
		fileHash: null,
		fileName: null,
	},
	fetchedLanguages: [],
	IDsSelectedLanguages: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
	selectedTranslationTab: null,
	translations: [],
};

export interface IEditVideoContext extends IEditVideoState {
	refetchData(value: boolean): void;
	changeVisibleForm(value: TEditVideoVisibleForm): void;
	setFileId(value: TFileId): void;
	deletePhoto(): void;
	setFetchedStudios(value: IItemForGetShortInfo[]): void;
	setIDStudio(value: TEditVideoSelectedItem): void;
	refetchStudios(needRefetch: boolean): void;
	changeName(value: string): void;
	setFetchedCategories(value: IItemForGetShortInfo[]): void;
	setIDCategory(value: TEditVideoSelectedItem): void;
	changeFileData(value: IFileData): void;
	setFetchedLanguages(value: IItemForGetShortInfo[]): void;
	setIDsLanguages(value: TLanguageIDs[]): void;
	setDataForSubmit(data: IEditVideo | null): void;
	changeTypeOfModalWindow(value: TTypeOfEditVideoModalWindow): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	resetFields(): void;
}

export const EditVideoContext = createContext<IEditVideoContext>({
	refetchData: () => undefined,
	changeVisibleForm: () => undefined,
	setFileId: () => undefined,
	deletePhoto: () => undefined,
	setFetchedStudios: () => undefined,
	setIDStudio: () => undefined,
	refetchStudios: () => undefined,
	changeName: () => undefined,
	setFetchedCategories: () => undefined,
	setIDCategory: () => undefined,
	changeFileData: () => undefined,
	setFetchedLanguages: () => undefined,
	setIDsLanguages: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	resetFields: () => undefined,
	...editVideoInitialState,
});
